export const phoneData = {
    title:"(929) 385-27-37",
    value:"+79293852737"
}

export const phoneDataPriority = {
    title:"(383) 375-91-30",
    value:"+73833759130"
}
